var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "event-card-head" },
    [
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _vm.item.TicketConflictCode
            ? _c("el-checkbox", {
                staticClass: "mr-2",
                model: {
                  value: _vm.conflictCodeChecked,
                  callback: function ($$v) {
                    _vm.conflictCodeChecked = $$v
                  },
                  expression: "conflictCodeChecked",
                },
              })
            : _vm.labels["registration-locked"]
            ? _c("el-checkbox", {
                staticClass: "mr-2",
                model: {
                  value: _vm.registrationLockedChecked,
                  callback: function ($$v) {
                    _vm.registrationLockedChecked = $$v
                  },
                  expression: "registrationLockedChecked",
                },
              })
            : _vm.maxAvailableTickets === 1
            ? _c("el-checkbox", {
                staticClass: "mr-2",
                model: {
                  value: _vm.singleTicketOptionChecked,
                  callback: function ($$v) {
                    _vm.singleTicketOptionChecked = $$v
                  },
                  expression: "singleTicketOptionChecked",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "event-card-avatar" }, [
            _c("div", { staticClass: "event-initial-bg" }),
            _vm._v(" "),
            _c("div", { staticClass: "event-initial-text font-light" }, [
              _vm.item.TicketType === "table"
                ? _c("img", {
                    attrs: {
                      src: require("../../assets/icons/table.svg"),
                      alt: "Table",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.item.TicketType === "individual"
                ? _c("img", {
                    attrs: {
                      src: require("../../assets/icons/user-icon.svg"),
                      alt: "User",
                    },
                  })
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "event-card-title" }, [
            _c("div", { staticClass: "event-individual-title" }, [
              _vm._v(_vm._s(_vm.item.TicketName)),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "event-individual-price font-light" },
              [
                _vm.item.TicketPrice > 0
                  ? [
                      _vm._v(
                        "$" + _vm._s(_vm.item.TicketPrice.toLocaleString())
                      ),
                    ]
                  : [_vm._v(_vm._s(_vm.labels["ticket-label-complimentary"]))],
              ],
              2
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.labels["registration-locked"]
        ? [
            _vm.maxAvailableTickets === 0
              ? _c("span", { staticClass: "exhausted" }, [
                  _vm._v("Allocation exhausted"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.maxAvailableTickets > 1
              ? _c(
                  "div",
                  { staticClass: "event-qty-select" },
                  [
                    _c(
                      "el-select",
                      {
                        model: {
                          value: _vm.totalTicket,
                          callback: function ($$v) {
                            _vm.totalTicket = $$v
                          },
                          expression: "totalTicket",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "Select", value: "0" },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.maxAvailableTickets, function (n) {
                          return _c("el-option", {
                            key: n,
                            attrs: { value: n, label: n },
                          })
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }